import React from 'react';
import { Suche } from '../../icons';
import './ModalDeviceSearch.css';

export function ModalDeviceSearch({
  searchValue,
  onSearchChange,
  suggestions,
  showSuggestions,
  onFocusShow,
  onBlurHide,
  onHideSuggestions,
  highlightedIndex,
  onHighlightChange,
  onSelect,
  onClearSearch,
  onEscapeClose,
  suggestionsRef,
  selectedDevices,
  onRemoveDevice,
  inputId = 'device-search-input',
  label = 'Endgerät suchen',
}) {
  return (
    <>
      <div className="modal-device-search-wrapper">
        <label htmlFor={inputId} className="modal-device-search-label">
          {label}
        </label>
        <span className="modal-device-search-icon"><Suche /></span>
        <input
          id={inputId}
          className="modal-device-search-input"
          value={searchValue}
          onChange={e => {
            onSearchChange(e.target.value);
            onHighlightChange(-1);
          }}
          onFocus={onFocusShow}
          onBlur={onBlurHide}
          onKeyDown={e => {
            if (e.key === 'Escape') {
              if (showSuggestions && suggestions.length > 0) {
                onHideSuggestions();
                onHighlightChange(-1);
              } else {
                onEscapeClose();
              }
              return;
            }
            if (!showSuggestions || suggestions.length === 0) return;
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              onHighlightChange(Math.min(highlightedIndex + 1, suggestions.length - 1));
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              onHighlightChange(Math.max(highlightedIndex - 1, -1));
            } else if (e.key === 'Enter' && highlightedIndex >= 0) {
              e.preventDefault();
              onSelect(suggestions[highlightedIndex]);
            }
          }}
          placeholder="Endgerät suchen"
          autoFocus
          aria-autocomplete="list"
          aria-controls="device-suggestions"
          aria-activedescendant={
            highlightedIndex >= 0 && showSuggestions && suggestions.length > 0
              ? `device-suggestion-${highlightedIndex}`
              : undefined
          }
        />
        {searchValue && (
          <button
            className="modal-device-search-clear"
            onClick={onClearSearch}
            aria-label="Eingabe zurücksetzen"
            title="Eingabe zurücksetzen"
          >
            ✖
          </button>
        )}
        {showSuggestions && suggestions.length > 0 && (
          <div
            id="device-suggestions"
            className="modal-device-search-suggestions"
            role="listbox"
            ref={suggestionsRef}
          >
            {suggestions.map((d, idx) => (
              <div
                key={d.id.id}
                id={`device-suggestion-${idx}`}
                className={`modal-device-search-suggestion ${highlightedIndex === idx ? 'highlighted' : ''}`}
                role="option"
                aria-selected={highlightedIndex === idx}
                onMouseDown={() => onSelect(d)}
                onMouseEnter={() => onHighlightChange(idx)}
              >
                {d.name}
              </div>
            ))}
          </div>
        )}
        {showSuggestions && suggestions.length === 0 && searchValue && (
          <div className="modal-device-search-suggestions" role="listbox">
            <div className="modal-device-search-suggestion-no-results">Keine Ergebnisse</div>
          </div>
        )}
      </div>
      {selectedDevices.length > 0 && (
        <div className="selected-badges">
          {selectedDevices.map(d => (
            <span key={d.id} className="selected-badge">
              {d.name}
              <button
                type="button"
                className="badge-remove"
                onClick={() => onRemoveDevice(d.id)}
                aria-label="Endgerät entfernen"
                title="Endgerät entfernen"
              >
                ✖
              </button>
            </span>
          ))}
        </div>
      )}
    </>
  );
}
